import {
  EDIT_PACK, DELETE_PACK, CREATE_PACK, CREATE_PACK_SUCCESS, UPDATE_PACK_SUCCESS,
  UPDATE_PACK, DELETE_PACK_SUCCESS, FETCH_ALL_PACK, FETCH_ALL_PACK_SUCCESS, SET_PACK, SET_ROLE
} from 'constants/packs.constants'
import { startLoader } from 'actions/general.action';

export const setPack = (key, value) => {
  return {
    type: SET_PACK,
    key: key,
    value: value
  }
}

export const setRoles = (key, value) => {
  return {
    type: SET_ROLE,
    key: key,
    value: value
  }
}

export const fetchPacks = (page) => {
  return dispatch => {
    dispatch({
      type: FETCH_ALL_PACK,
      payload: page
    })
    dispatch(startLoader())
  }
}

export const fetchPacksSuccess = (data) => {
  return {
    type: FETCH_ALL_PACK_SUCCESS,
    payload: data
  };
};

export const deletePack = (id) => {
  return {
    type: DELETE_PACK,
    payload: id
  };
};

export const editPack = (id) => {
  return {
    type: EDIT_PACK,
    payload: id
  };
};

export const createPack = (payload) => {
  console.log(payload)
  return {
    type: CREATE_PACK,
    payload: payload
  };
};

export const createPackSuccess = (payload) => {
  return {
    type: CREATE_PACK_SUCCESS,
    payload: payload
  };
};

export const updatePackSuccess = (data) => {
  return {
    type: UPDATE_PACK_SUCCESS,
    payload: data
  };
};

export const deletePackSuccess = (data) => {
  return {
    type: DELETE_PACK_SUCCESS,
    payload: data
  };
};

export const updatePack = (payload) => {
  return {
    type: UPDATE_PACK,
    payload: payload
  };
}; 